import React from 'react'

function PageNotFound() {
  return (
    <div className="p-5 m-t5 row">
      <div className="d-inline col-12">
        <h4 className="mt-3">404 Page Not Found</h4>
        <p className="text-muted">Maybe it's time to get off the internet!</p>
      </div>
    </div>
  )
}

export default PageNotFound
